const RefreshButton = () => {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="h-full select-none"
    >
      <path
        d="M17.4388 12.0313C17.006 11.8422 16.5022 12.0398 16.3132 12.4724C15.1298 15.1809 12.4556 16.931 9.50035 16.931C7.15774 16.931 4.99203 15.83 3.60507 14.0244L6.52464 14.6051C6.98774 14.6972 7.43767 14.3964 7.52982 13.9334C7.62192 13.4704 7.32118 13.0203 6.85815 12.9282L2.0708 11.976C1.60776 11.8841 1.15778 12.1846 1.06562 12.6477L0.113387 17.435C0.0212918 17.8981 0.322025 18.3481 0.785064 18.4402C0.84137 18.4514 0.897448 18.4568 0.952727 18.4568C1.35222 18.4568 1.70932 18.1752 1.79024 17.7685L2.31158 15.1475C4.01967 17.3201 6.65429 18.6407 9.50035 18.6407C13.1351 18.6407 16.4243 16.4882 17.8798 13.1569C18.0689 12.7243 17.8714 12.2204 17.4388 12.0313Z"
        fill="white"
      />
      <path
        d="M18.2151 0.559351C17.7521 0.46737 17.302 0.767989 17.2099 1.23103L16.6885 3.85237C14.9804 1.67993 12.3458 0.359375 9.50005 0.359375C5.86532 0.359375 2.57612 2.51192 1.12044 5.84313C0.931403 6.27574 1.12887 6.77969 1.56148 6.96873C1.67295 7.0174 1.78904 7.04048 1.90336 7.04048C2.23281 7.04048 2.54677 6.84888 2.68713 6.52769C3.87069 3.81915 6.54492 2.069 9.50011 2.069C11.8423 2.069 14.008 3.16981 15.3949 4.97518L12.4755 4.3944C12.0123 4.30236 11.5624 4.60298 11.4702 5.06602C11.3781 5.52906 11.6788 5.97911 12.1419 6.07126L16.9293 7.02361C16.9846 7.03461 17.0405 7.04002 17.0961 7.04002C17.264 7.04002 17.4295 6.99055 17.571 6.89595C17.7595 6.77 17.8903 6.5743 17.9345 6.35193L18.8867 1.56447C18.9789 1.10149 18.6781 0.651446 18.2151 0.559351Z"
        fill="white"
      />
    </svg>
  );
};

export default RefreshButton;
